import { Component, OnInit, Input } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AttivitaReale } from 'src/app/models/didattica/attivita-reale';
import { FreqInfo } from 'src/app/models/didattica/frequinfo';
import { Recupero } from 'src/app/models/recupero';
import { RecuperoService } from 'src/app/services/recupero-service';
import { UserService } from 'src/app/services/user-service';
import { UtilityService } from 'src/app/services/utility.service';


@Component({
    selector: 'app-mod-freq-viewer',
    templateUrl: './mod-freq-viewer.component.html',
    styleUrls: ['./mod-freq-viewer.component.scss'],
    standalone: false
})
export class ModFreqViewerComponent implements OnInit {

  @Input() freqInfos: FreqInfo[];
  @Input() mods: AttivitaReale[];
  @Input() freqVsTotAr: boolean;
  @Input() abilitaRecuperi: boolean;
  @Input() verificaIdoneitaSingoliModuli: boolean;

  recuperi: Recupero[] = [];
  selezioneEffettuata: boolean;
  complete: boolean;
  selected: boolean[];
  disabled: boolean[];
  currentYearAr: boolean;
  studentMessage: string;

  constructor(
    public modalCtrl: ModalController,
    private recuperoService: RecuperoService,
    private userService: UserService,
    private loadingCtrl: LoadingController,
    private utilityService: UtilityService,
    private translateService: TranslateService,
    ) {
  }

  ngOnInit() {
    console.log('abilitaRecuperi', this.abilitaRecuperi);
    console.log('mods', this.mods);
    console.log('freqInfos', this.freqInfos);
    console.log('freqVsTotAr', this.freqVsTotAr);

    if (this.abilitaRecuperi) {
      // vanno caricati i recuperi eventualmente già richiesti dallo studente
      this.getRecuperiStudente();
      this.selected = [];
      this.disabled = [];
      for (let i = 0; i < this.mods.length; i++) {
        this.recuperi[i] = undefined;
        this.selected[i] = false;
        this.disabled[i] = false;
        this.mods[i].idAttivitaReale = this.mods[i].id.split(':')[1];
      }
    }

    if (this.verificaIdoneitaSingoliModuli!==undefined) {
      this.studentMessage = this.translateService.instant('mod-freq-viewer.message.verificasingolimoduli', 
          {non: this.verificaIdoneitaSingoliModuli? '': 'non '});
    }
  }

  async getRecuperiStudente() {
    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });
    loader.present();
    this.recuperoService.getRecuperiStudente(
      this.userService.getStudenteCorrente().id, '2023')
        .subscribe(recuperi => {
          console.log('recuperi', recuperi);
          // se trova dei recuperi verifica che siano realtivi ai moduli caricati nella maschera
          // li seleziona e li disabilita tramite gli'array selected e disabled
          if (recuperi) {
            for (let i = 0; i < this.mods.length; i++) {
              const recs = recuperi.filter(r => r.idArFrequenza === this.mods[i].idAttivitaReale);
              if (recs.length === 1) {
                this.recuperi[i] = recs[0];
                this.selected[i] = true;
                this.disabled[i] = true;
              }
            }
          }
          console.log('this.recuperi', this.recuperi);
          console.log('this.selection', this.selected);
          loader.dismiss();
      },
      error => {
        loader.dismiss();
        this.utilityService.showError(error);
      }
    );
  }

  aggiornaSelezione() {
      for (let i = 0; i < this.mods.length; i++) {
        console.log('this.selection[i] ' + i, this.selected[i]);
        if (this.selected[i] && !this.disabled[i]) {
          // se ne trova almeno uno selezionato e non disabilitato imposta a true selezioneEffettuata
          this.selezioneEffettuata = true;
          this.complete = false;
          return;
        }
      }
      // se arriva qui vuol dire che nessuna selezione è valida
      this.selezioneEffettuata = false;
   }

  async richiediReuperi() {
    const selectedMods: AttivitaReale[] = [];
    const selectedFreqinfos: FreqInfo[] = [];
    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });
    loader.present();
    for (let i = 0; i < this.selected.length; i++) {
      if (this.selected[i] && !this.disabled[i]) {
        this.freqInfos[i].idoneitadoc = false; // è undefined e il rest esposto dal bff va in errore
        selectedMods.push(this.mods[i]);
        selectedFreqinfos.push(this.freqInfos[i]);
      }
    }

    this.recuperoService.richiediRecuperi(
      this.userService.getStudenteCorrente(), selectedMods, selectedFreqinfos)
        .subscribe(recuperi => {
          console.log('recuperi', recuperi);
          // i recuperi vanno accoppiati ai moduli, tramite l'idAr per i quali è stata fatta richiesta
          if (recuperi) {

            for (let i = 0; i < this.mods.length; i++) {
              const recs = recuperi.filter(r => r.idArFrequenza === this.mods[i].idAttivitaReale);
              if (recs.length > 0) {
                this.recuperi[i] = recs[0];
                this.disabled[i] = true;
              }
            }
          console.log('this.recuperi', this.recuperi);
          }
          loader.dismiss();
          this.complete = true;
      },
      error => {
        loader.dismiss();
        this.utilityService.showError(error);
      }
    );

  }


}
